import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=e51b6af0&scoped=true&"
import script from "./chatBox.vue?vue&type=script&lang=js&"
export * from "./chatBox.vue?vue&type=script&lang=js&"
import style0 from "./chatBox.vue?vue&type=style&index=0&id=e51b6af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51b6af0",
  null
  
)

export default component.exports